// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.measurement-section {
  margin-bottom: 32px;
  width: 168px;
  border-radius: 14px;
  background-color: var(--light-orange);
}

.measurement-section button {
  display: inline-block;
  font-weight: 400;
  line-height: 18px;
  font-size: 13px;
  font-style: normal;
  text-transform: uppercase;
  text-align: center;
  outline: none;
  cursor: pointer;
  border: 1px solid var(--measurement-section-button-active);
  border-radius: 14px;
  width: 50%;
  height: 36px;
  padding: 6px 10px;
  background: var(--light-orange);
  color: var(--orange)
}

.measurement-section button.selected {
  background: var(--orange);
  color: var(--white);
  border: 2px solid var(--light-orange);
  font-weight: 700;
  line-height: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.measurement-section.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,0DAA0D;EAC1D,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".measurement-section {\n  margin-bottom: 32px;\n  width: 168px;\n  border-radius: 14px;\n  background-color: var(--light-orange);\n}\n\n.measurement-section button {\n  display: inline-block;\n  font-weight: 400;\n  line-height: 18px;\n  font-size: 13px;\n  font-style: normal;\n  text-transform: uppercase;\n  text-align: center;\n  outline: none;\n  cursor: pointer;\n  border: 1px solid var(--measurement-section-button-active);\n  border-radius: 14px;\n  width: 50%;\n  height: 36px;\n  padding: 6px 10px;\n  background: var(--light-orange);\n  color: var(--orange)\n}\n\n.measurement-section button.selected {\n  background: var(--orange);\n  color: var(--white);\n  border: 2px solid var(--light-orange);\n  font-weight: 700;\n  line-height: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
